import React, { useMemo, RefForwardingComponent } from 'react'
import { Dropdown } from 'react-bootstrap'
import styles from './styles/generic-components.module.scss'
import cx from 'classnames'

interface Props {
  defaultLabel?: string
  label: string
}

/**
 * https://react-bootstrap.netlify.com/components/dropdowns/#custom-dropdown-components
 * > Custom toggle and menu components must be able to accept refs.
 */
export const useForwardedRefOnMount = <Props extends {}>(
  Component: RefForwardingComponent<any, Props>
) => useMemo(() => React.forwardRef(Component), [Component])

const CustomDropDownLabel: React.FC<{ label: string; onClick: () => void }> = (
  { label, onClick },
  ref
) => (
  <button
    {...{ ref, onClick }}
    className={cx(
      styles.customDropdown,
      styles.labelPadding,
      'generic-components_customDropdown--override'
    )}
  >
    <div className={cx(styles.dropdownLabel, 'generic-components_dropdownLabel--override')}>
      {label}
    </div>
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='-6 0 24 24'>
      <path
        stroke='#003A70'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth='1.5'
        d='M16.5 9.6L12 14.4 7.5 9.6'
      />
    </svg>
  </button>
)

const DropdownLabel = React.memo<Props>(({ defaultLabel, label }) => {
  // @ts-ignore
  const ForwardedLabel = useForwardedRefOnMount(CustomDropDownLabel)
  return (
    <Dropdown.Toggle
      //@ts-ignore
      as={ForwardedLabel}
      {...{ id: defaultLabel || label, label }}
    />
  )
})

export default DropdownLabel
